'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M48 144l416 0 0 320L48 464l0-320zm48 48l0 224 256 0 0-224L96 192zm296 32a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z', 'M168 6.1l17 17 71 71 71-71 17-17L377.9 40 361 57l-39 39L464 96l48 0 0 48 0 320 0 48-48 0L48 512 0 512l0-48L0 144 0 96l48 0 142.1 0L151 57l-17-17L168 6.1zM48 144l0 320 416 0 0-320L48 144zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 192l0 224L96 416l0-224 256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;